import React from 'react';
import { CircularProgress, Grid } from '@material-ui/core/';

const Loading = ({ minHeight = 200 }) => (
    <Grid container justify="center" alignItems="center" style={{ minHeight }}>
        <CircularProgress className="yeself-loading" />
    </Grid>
);

export default Loading;
